import { Col, DatePicker, Form, Input, Row, Select, Card } from "antd";
import {
  UserOutlined,
  HomeOutlined,
  PhoneOutlined,
  HeartOutlined,
  DollarOutlined,
} from "@ant-design/icons";
import React from "react";
import {
  eduOptions,
  familyStatusOptions,
  healthOptions,
  homeStatus2Options,
  homeStatusOptions,
  homeTypeOptions,
  materialStatusOptions,
  professionOptions,
  swidaVillagesFull,
} from "pages/Family/components/constants/constants";
import { getCountries } from "./helper";

const FatherForm = () => {
  return (
    <div className="space-y-6">
      {/* 👤 Personal Information */}
      <Card
        title={
          <span className="text-lg font-semibold flex items-center gap-2 text-indigo-600">
            <UserOutlined /> المعلومات الشخصية
          </span>
        }
        bordered={false}
        className="shadow-sm bg-gray-50"
      >
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12} lg={6}>
            <Form.Item
              name={["father", "familyBookNumber"]}
              label="رقم دفتر العائلة"
              // getValueFromEvent={(e) => {
              //   const val = normalizeDigits(e?.target?.value ?? "");
              //   return val.replace(/[^\d.-]/g, "");
              // }}
            >
              <Input
                style={{ maxWidth: "100%" }}
                type="string"
                inputMode="text"
                placeholder="أدخل الرقم"
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={8}>
            <Form.Item name={["father", "firstName"]} label="الاسم">
              <Input placeholder="أدخل الاسم" />
            </Form.Item>
          </Col>
          <Col xs={24} sm={8}>
            <Form.Item name={["father", "middleName"]} label="اسم الأب">
              <Input placeholder="أدخل اسم الأب" />
            </Form.Item>
          </Col>
          <Col xs={24} sm={8}>
            <Form.Item name={["father", "lastName"]} label="الكنية">
              <Input placeholder="أدخل الكنية" />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} lg={6}>
            <Form.Item name={["father", "nationality"]} label="الجنسية">
              <Select
                showSearch
                style={{ width: "100%" }}
                optionFilterProp="label"
                filterOption={(input, option) => {
                  const label =
                    typeof option?.label === "string" ? option.label : "";
                  console.log(label);
                  return label.toLowerCase().includes(input.toLowerCase());
                }}
              >
                {getCountries().map((country: any) => (
                  <Select.Option
                    key={country.iso3}
                    value={country.nationality}
                    label={country.nationality}
                  >
                    <span
                      style={{
                        marginRight: 8,
                        backgroundImage: `url(https://flagcdn.com/16x12/${country.iso2.toLowerCase()}.png)`,
                        backgroundSize: "cover",
                        display: "inline-block",
                        width: 16,
                        height: 12,
                      }}
                    />
                    {" " + country.nationality}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} lg={6}>
            <Form.Item name={["father", "nationalId"]} label="الرقم الوطني">
              <Input type="number" placeholder="أدخل الرقم الوطني" />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} lg={6}>
            <Form.Item name={["father", "birthdate"]} label="تاريخ الميلاد">
              <DatePicker format="DD-MM-YYYY" className="w-full" />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} lg={6}>
            <Form.Item name={["father", "education"]} label="التحصيل العلمي">
              <Select
                allowClear
                showSearch
                placeholder="اختر التحصيل العلمي"
                options={eduOptions}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} lg={6}>
            <Form.Item name={["father", "professional"]} label="المهنة">
              <Select
                allowClear
                showSearch
                placeholder="اختر المهنة"
                options={professionOptions}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} lg={6}>
            <Form.Item name={["father", "jobTitle"]} label="المسمى الوظيفي">
              <Input placeholder="أدخل المسمى الوظيفي" />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} lg={6}>
            <Form.Item name={["father", "workplace"]} label="مكان العمل">
              <Input placeholder="أدخل مكان العمل" />
            </Form.Item>
          </Col>
        </Row>
      </Card>

      {/* 🏠 Social & Housing Information */}
      <Card
        title={
          <span className="text-lg font-semibold flex items-center gap-2 text-indigo-600">
            <HomeOutlined /> الحالة الاجتماعية والسكن
          </span>
        }
        bordered={false}
        className="shadow-sm bg-gray-50"
      >
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12} lg={6}>
            <Form.Item
              name={["father", "materialStatus"]}
              label="الحالة الاجتماعية"
            >
              <Select
                allowClear
                showSearch
                placeholder="اختر الحالة الاجتماعية"
                options={materialStatusOptions}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} lg={6}>
            <Form.Item
              name={["father", "familyStatus"]}
              label="الحالة العائلية"
            >
              <Select
                allowClear
                showSearch
                placeholder="اختر الحالة العائلية"
                options={familyStatusOptions}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} lg={6}>
            <Form.Item name={["father", "village"]} label="القرية">
              <Select
                allowClear
                showSearch
                placeholder="اختر القرية"
                options={swidaVillagesFull}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} lg={6}>
            <Form.Item name={["father", "address"]} label="العنوان">
              <Input placeholder="أدخل العنوان" />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} lg={6}>
            <Form.Item name={["father", "description"]} label="الخانة">
              <Input placeholder="أدخل الخانة" allowClear />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} lg={6}>
            <Form.Item name={["father", "homeType"]} label="نوع السكن">
              <Select
                allowClear
                showSearch
                placeholder="اختر نوع السكن"
                options={homeTypeOptions}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} lg={6}>
            <Form.Item name={["father", "homeStatus"]} label="حالة السكن">
              <Select
                allowClear
                showSearch
                placeholder="اختر حالة السكن"
                options={homeStatusOptions}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} lg={6}>
            <Form.Item name={["father", "homeStatus2"]} label="حالة السكن ٢">
              <Select
                allowClear
                showSearch
                placeholder="اختر حالة السكن"
                options={homeStatus2Options}
              />
            </Form.Item>
          </Col>
        </Row>
      </Card>

      {/* 💰 Financial Information */}
      <Card
        title={
          <span className="text-lg font-semibold flex items-center gap-2 text-indigo-600">
            <DollarOutlined /> المعلومات المالية
          </span>
        }
        bordered={false}
        className="shadow-sm bg-gray-50"
      >
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12} lg={6}>
            <Form.Item name={["father", "salary"]} label="الراتب">
              <Input type="number" placeholder="أدخل الراتب" />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} lg={6}>
            <Form.Item name={["father", "income"]} label="الدخل السنوي">
              <Input type="number" placeholder="أدخل الدخل السنوي" />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} lg={6}>
            <Form.Item
              name={["father", "expectedFamilyExpenses"]}
              label="نفقات الأسرة"
            >
              <Input type="number" placeholder="أدخل نفقات الأسرة" />
            </Form.Item>
          </Col>
        </Row>
      </Card>

      {/* ☎️ Contact Information */}
      <Card
        title={
          <span className="text-lg font-semibold flex items-center gap-2 text-indigo-600">
            <PhoneOutlined /> معلومات الاتصال
          </span>
        }
        bordered={false}
        className="shadow-sm bg-gray-50"
      >
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12} lg={6}>
            <Form.Item name={["father", "phone"]} label="الموبايل ١">
              <Input type="number" placeholder="أدخل رقم الموبايل ١" />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} lg={6}>
            <Form.Item name={["father", "mobile2"]} label="الموبايل ٢">
              <Input type="number" placeholder="أدخل رقم الموبايل ٢" />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} lg={6}>
            <Form.Item name={["father", "homePhone"]} label="الهاتف الأرضي">
              <Input type="number" placeholder="أدخل الهاتف الأرضي" />
            </Form.Item>
          </Col>
        </Row>
      </Card>

      {/* ❤️ Health Information */}
      <Card
        title={
          <span className="text-lg font-semibold flex items-center gap-2 text-indigo-600">
            <HeartOutlined /> الحالة الصحية
          </span>
        }
        bordered={false}
        className="shadow-sm bg-gray-50"
      >
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12} lg={6}>
            <Form.Item name={["father", "healthStatus"]} label="الحالة الصحية">
              <Select
                allowClear
                showSearch
                placeholder="اختر الحالة الصحية"
                options={healthOptions}
              />
            </Form.Item>
          </Col>
        </Row>
      </Card>
    </div>
  );
};

export default FatherForm;
